import {client, modules, router} from "@intermesh/groupoffice-core";
import {MainPanel} from "./MainPanel.js";
import {translate} from "@intermesh/goui";
import {FormWindow} from "./FormWindow";
import {FormDetail} from "./FormDetail";
import {t} from "./Translate";
import {SystemSettings} from "./SystemSettings.js";

modules.register(  {
	package: "business",
	name: "forms",
	entities: [
		"FormBook",
		"FormParticipant",
		{
			name:"Form",
			filters: [
				{
					name: 'text',
					type: "string",
					multiple: false,
					title: t("Query")
				},
				{
					name: 'title',
					type: "string",
					multiple: true,
					title: t("Name")
				},
				{
					name: 'formBookId',
					type: "string",
					multiple: true,
					title: t("Book")
				},
				{
					title: t("Has links to..."),
					name: 'link',
					multiple: false,
					type: 'go.links.FilterLinkEntityCombo'
				},
				{
					title: t("Commented at"),
					name: 'commentedat',
					multiple: false,
					type: 'date'
				}, {
					title: t("Modified at"),
					name: 'modifiedat',
					multiple: false,
					type: 'date'
				}, {
					title: t("Modified by"),
					name: 'modifiedBy',
					multiple: true,
					type: 'string'
				}, {
					title: t("Created at"),
					name: 'createdat',
					multiple: false,
					type: 'date'
				}, {
					title: t("Created by"),
					name: 'createdby',
					multiple: true,
					type: 'string'
				}
			],

			links: [{
				iconCls: 'entity ic-note yellow',
				/**
				 * Opens a dialog to create a new linked item
				 *
				 * @param {string} entity eg. "Note"
				 * @param {string|int} entityId
				 * @returns FormWindow
				 */
				linkWindow: (entity:string, entityId) => {
					return new FormWindow();
				},

				/**
				 * Return component for the detail view
				 */
				linkDetail () {
					return new FormDetail();
				}
			}]
		}
	],
	async init () {
		client.on("authenticated",  ( {session}) => {

			if(!session.capabilities["go:business:forms"]) {
				// User has no access to this module
				return;
			}

			translate.load(GO.lang.business.forms, "business", "forms");

			const mainPanel = new MainPanel();

			router.add(/^forms\/(\d+)$/, (FormId) => {
				modules.openMainPanel("forms");
				mainPanel.setFormId(FormId);
			});

			router.add(/^forms$/, () => {
				modules.openMainPanel("forms");
				// mainPanel.setTaskId();
			});

			modules.addMainPanel( "business", "forms", "forms", t("Forms"), () => {
				return mainPanel;
			});


			if (session.capabilities["go:business:forms"].mayManage) {
				modules.addSystemSettingsPanel("business", "forms", "forms", t("Forms"), "description", () => {
					return new SystemSettings();
				});
			}
		});
	}
});


